export type Bonus = {
  number: string
  name: string
  description: string
  includes: string[]
  value: number
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    name: 'Mobility for All Joints',
    description: 'Full-body mobility exercises and ready-to-use routines.',
    includes: [
      'Neck, shoulder & thoracic mobility',
      'Hip, knee & ankle mobility',
      'Wrist & elbow mobility drills',
      'Ready-to-use full-body routines',
    ],
    value: 12,
  },
  {
    number: '02',
    name: 'Rehabilitation at Home',
    description: 'Practical routines using bodyweight, bands, a chair, wall and simple equipment.',
    includes: [
      'Bodyweight exercise options',
      'Resistance band progressions',
      'Chair & wall-supported exercises',
      'Complete home routines by body area',
    ],
    value: 12,
  },
  {
    number: '03',
    name: 'Rehabilitation at the Gym',
    description: 'Exercises using machines, cables, dumbbells, bands and common gym equipment.',
    includes: [
      'Machine & cable exercises',
      'Dumbbell strength progressions',
      'Band & accessory options',
      'Structured gym routines by level',
    ],
    value: 15,
  },
  {
    number: '04',
    name: 'Joint Prevention & Strengthening',
    description: 'Strength, stability, joint control and capacity-building routines.',
    includes: [
      'Joint stability exercises',
      'Strength & control progressions',
      'Balance & proprioception work',
      'Capacity-building weekly routines',
    ],
    value: 12,
  },
  {
    number: '05',
    name: 'Warm-Up & Stretching',
    description: 'Dynamic warm-ups, joint preparation and post-training stretching protocols.',
    includes: [
      'Dynamic warm-up sequences',
      'Joint preparation drills',
      'Upper & lower-body stretches',
      'Post-training stretching protocols',
    ],
    value: 10,
  },
]

export const pricing = {
  systemValue: 40,
  bonusValue: 61,
  totalValue: 101,
  price: 27,
  savings: 74,
}

export const systemStack = [
  '5 Complete Rehabilitation & Strengthening Volumes',
  'Beginner → Advanced',
  'Mobility + Strength + Stability',
  'Sets + Reps + Rest Included',
  'Regressions + Progressions',
  'Home + Gym Options',
  'Complete Ready-to-Follow Routines',
]

export const checkoutAssurances = ['Instant Digital Access', 'One-Time Payment', '7-Day Guarantee', 'Secure Payment']
